// extracted by mini-css-extract-plugin
module.exports = {"loader":"video-placeholder_loader__mvxV7","playBtn":"video-placeholder_playBtn__EN3mC","image":"video-placeholder_image__uPocO"};